import { createTheme } from '@mui/material';

const theme = createTheme({
  typography: {
    fontFamily: 'Inter, system-ui',
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: 'Inter, system-ui, sans-serif',
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          fontFamily: 'Inter, system-ui, sans-serif',
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        asterisk: {
          color: '#d32f2f',
        },
      },
    },
  },
});

export default theme;
